/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const EpisodeList: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="episode-list" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M0 1020H113.3333333333333V340H0zM1246.6666666666665 1020H1360V340H1246.6666666666665zM1020 1133.3333333333333A113.3333333333333 113.3333333333333 0 0 0 1133.3333333333333 1020V340A113.3333333333333 113.3333333333333 0 0 0 1020 226.6666666666668H226.6666666666667V1020A113.3333333333333 113.3333333333333 0 0 0 340 1133.3333333333333H1020zM340 340H1020V1020H340V340z" : "M0 816H90.6666666666667V272H0zM997.3333333333334 816H1088V272H997.3333333333334zM816 906.6666666666666A90.6666666666667 90.6666666666667 0 0 0 906.6666666666669 816V272A90.6666666666667 90.6666666666667 0 0 0 816 181.3333333333333H181.3333333333334V816A90.6666666666667 90.6666666666667 0 0 0 272 906.6666666666666H816zM272 272H816V816H272V272z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
EpisodeList.displayName = `Blueprint5.Icon.EpisodeList`;
export default EpisodeList;
